import {
    GET_CURRENT_CONDITIONS_OBS_DATA,
    GET_CURRENT_CONDITIONS_HOURLY_DATA,
    GET_CURRENT_CONDITIONS_DAILY_DATA
} from '../actions/currentConditionsActions';

import { LOCATION_CHANGED } from '../actions/locationActions';

const lastObsError = 'lastObsError';
const lastHourlyError = 'lastHourlyError';
const lastDailyError = 'lastDailyError';
const currentStationObs = 'currentStationObs';
const hourlyForecastData = 'hourlyForecastData';
const dailyForecastData = 'dailyForecastData';

export const initialState = {
    currentConditionsIsRefreshing: false,
    currentConditions: undefined,
    currentStationObs: undefined,
    hourlyForecastData: undefined,
    dailyForecastData: undefined,
    lastObsError: undefined,
    lastHourlyError: undefined,
    lastDailyError: undefined,
    lastError: undefined
};

function getBestCurrentConditionsData({ currentStationObs, hourlyForecastData, dailyForecastData }) {
    let result = {
        obsData: currentStationObs
    };

    if (currentStationObs) {
        result.low = parseFloat(currentStationObs.hl?.tl) || undefined;
        result.ic = currentStationObs?.o?.ic;
        result.d = currentStationObs?.o?.id;
    }

    if (dailyForecastData?.dfp?.length) {
        const dayForecast = dailyForecastData.dfp[0].intp ? undefined : dailyForecastData.dfp[0];
        const nightForecast = dailyForecastData.dfp.find(f => f.intp);
        const obsTemp = parseFloat(currentStationObs?.o?.t) || undefined;

        if (dayForecast?.t !== undefined) {
            // We have a daily forecast temperature so set the hi from obs if we have it then take the daily hi if it is higher
            result.hi = parseFloat(currentStationObs?.hl?.th) || undefined;

            if (result.hi === undefined || obsTemp > result.hi) {
                result.hi = obsTemp;
            }

            const dailyTemp = parseFloat(dayForecast.t) || undefined;

            if (result.hi === undefined || dailyTemp > result.hi) {
                result.hi = dailyTemp;
            }
            if (result.low === undefined || dailyTemp < result.low) {
                result.low = dailyTemp;
            }
        }

        if (nightForecast?.t !== undefined) {
            const nightlyTemp = parseFloat(nightForecast.t) || undefined;
            if (result.low === undefined || nightlyTemp < result.low) {
                result.low = nightlyTemp;
            }
        }

        if (result.low !== undefined && currentStationObs?.o?.t < result.low) {
            result.low = obsTemp;
        }
    }

    if (hourlyForecastData?.hfp?.length > 0) {
        const zeroHour = hourlyForecastData.hfp[0];
        result.d = zeroHour?.d;
        result.ic = zeroHour?.ic;

        if (!currentStationObs && zeroHour?.t !== undefined) {
            result.obsData = {
                o: {
                    t: zeroHour?.t,
                    fl: zeroHour?.fl,
                    otals: zeroHour?.fdls
                }
            }
        }
    }

    return result;
}

function isDataLoading({ currentStationObs, hourlyForecastData, dailyForecastData, lastObsError, lastHourlyError, lastDailyError }) {
    const isObsLoading = !(currentStationObs || lastObsError);
    const isHourlyLoading = !(hourlyForecastData || lastHourlyError);
    const isDailyLoading = !(dailyForecastData || lastDailyError);

    return isObsLoading || isHourlyLoading || isDailyLoading;
}

function handleFulfilledData(state, dataFieldName, data) {
    const newState = {
        ...state,
        [dataFieldName]: data
    };

    newState.currentConditions = getBestCurrentConditionsData(newState);
    newState.currentConditionsIsRefreshing = isDataLoading(newState);
    return newState;
}

function handleRejectedData(state, errorFieldName, error) {
    const newState = {
        ...state,
        [errorFieldName]: error,
        lastError: error
    };
    newState.currentConditionsIsRefreshing = isDataLoading(newState);
    return newState;
}

export function currentConditionsObs(state = initialState, action) {
    switch (action.type) {
        case LOCATION_CHANGED:
        {
            return initialState;
        }
        case GET_CURRENT_CONDITIONS_OBS_DATA.pending:
        {
            return {
                ...state,
                currentStationObs: undefined,
                lastObsError: undefined,
                lastError: undefined,
                currentConditionsIsRefreshing: true,
                currentConditions: undefined
            }
        }
        case GET_CURRENT_CONDITIONS_HOURLY_DATA.pending:
        {
            return {
                ...state,
                hourlyForecastData: undefined,
                lastHourlyError: undefined,
                lastError: undefined,
                currentConditionsIsRefreshing: true,
                currentConditions: undefined
            }
        }
        case GET_CURRENT_CONDITIONS_DAILY_DATA.pending:
        {
            return {
                ...state,
                dailyForecastData: undefined,
                lastDailyError: undefined,
                lastError: undefined,
                currentConditionsIsRefreshing: true,
                currentConditions: undefined
            }
        }
        case GET_CURRENT_CONDITIONS_OBS_DATA.fulfilled:
        {
            return handleFulfilledData(state, currentStationObs, action.payload);
        }
        case GET_CURRENT_CONDITIONS_HOURLY_DATA.fulfilled:
        {
            return handleFulfilledData(state, hourlyForecastData, action.payload);
        }
        case GET_CURRENT_CONDITIONS_DAILY_DATA.fulfilled:
        {
            return handleFulfilledData(state, dailyForecastData, action.payload);
        }
        case GET_CURRENT_CONDITIONS_OBS_DATA.rejected:
        {
            return handleRejectedData(state, lastObsError, action.payload);
        }
        case GET_CURRENT_CONDITIONS_HOURLY_DATA.rejected:
        {
            return handleRejectedData(state, lastHourlyError, action.payload);
        }
        case GET_CURRENT_CONDITIONS_DAILY_DATA.rejected:
        {
            return handleRejectedData(state, lastDailyError, action.payload);
        }
        default:
        {
            return state;
        }
    }
}
